<div *ngIf="filterCol">
  <p class="filter-text">
    <criteria-display-text
      [criteria]="filterCol"
      [column]="column"
      [displaySymbols]="true"
    ></criteria-display-text>
  </p>
</div>
<div *ngIf="sortCol">
  <p *ngIf="sortCol.sort_ascending" class="filter-text">Sort ASC</p>
  <p *ngIf="!sortCol.sort_ascending" class="filter-text">Sort DESC</p>
</div>
